import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../../../../../atomic/formElements/checkBox/CheckBox';
import style from './FrontRun.module.css';
import InfoIconComponent from '../InfoIcon';
import evaluateQuotesDocs from '../../../documentation/evaluateQuotesDocs';
import PersistIfValidationOrFilterFailDocs from '../../../documentation/PersistIfValidationOrFilterFailDocs';
import FlattenAtMarketCloseDocs from '../../../documentation/FlattenAtMarketCloseDocumentation';
import terminateWhenFlatDoc from '../../../documentation/TerminateWhenFlatDocumentation';

// NOTE Front Run is logically referred to as evaluateQuotes
const FrontRun = ({ top, dispatchTop, showTerminateWhenFlat }) => {
  return (
    <div className={style.container}>
      <div className={style.checkRow}>
        <div className={style.checkboxAndTooltip}>
          <CheckBox
            margin="0 3px 0 0"
            checked={top.evaluateQuotes}
            onChange={(checked) =>
              dispatchTop({
                evaluateQuotes: checked,
              })
            }
          >
            Front Run
          </CheckBox>
          <InfoIconComponent docs={evaluateQuotesDocs} />
        </div>
        <div className={style.checkboxAndTooltip}>
          <CheckBox
            margin="0 3px 0 0"
            checked={top.persistTradePlanOnFailedFiltersOrValidation}
            onChange={(checked) =>
              dispatchTop({
                persistTradePlanOnFailedFiltersOrValidation: checked,
              })
            }
          >
            Persist if Validation/Filter Failure{' '}
          </CheckBox>
          <InfoIconComponent docs={PersistIfValidationOrFilterFailDocs} />
        </div>
      </div>
      <div className={style.checkRow}>
        <div className={style.checkboxAndTooltip}>
          <CheckBox
            margin="0 3px 0 0"
            checked={top.flattenAtMarketClose}
            onChange={(checked) =>
              dispatchTop({
                flattenAtMarketClose: checked,
              })
            }
          >
            Flatten at Market Close
          </CheckBox>
          <InfoIconComponent docs={FlattenAtMarketCloseDocs} />
        </div>
        {showTerminateWhenFlat ? (
          <div className={style.checkboxAndTooltip}>
            <CheckBox
              margin="0 3px 0 0"
              checked={top.terminateWhenFlat || false}
              onChange={(checked) =>
                dispatchTop({
                  terminateWhenFlat: checked,
                })
              }
            >
              Terminate When Flat
            </CheckBox>
            <InfoIconComponent docs={terminateWhenFlatDoc} />
          </div>
        ) : null}
      </div>
    </div>
  );
};
FrontRun.propTypes = {
  top: PropTypes.object.isRequired,
  dispatchTop: PropTypes.func.isRequired,
  showTerminateWhenFlat: PropTypes.bool.isRequired,
};
export default FrontRun;
